import { DropzoneState } from 'react-dropzone';
import { SetStateAction, Dispatch } from 'react';

export interface FileUploadResponse {
  attachmentId: string;
}

export interface UploadedFile extends File {
  preview: string;
  attachmentId: string;
}

export type OnDrop = (acceptedFiles: File[], rejectedFiles: File[]) => Promise<void> | void;
export type SetFile = Dispatch<SetStateAction<UploadedFile[]>>;

export interface ChildrenRenderProps {
  getInputProps: DropzoneState['getInputProps'];
  getRootProps: DropzoneState['getRootProps'];
  loading: boolean;
  files: UploadedFile[];
  setFiles: SetFile;
  acceptFileTypes: FileUploadProps['acceptFileTypes'];
}

export enum FileUploadError {
  FILE_TYPE_NOT_SUPPORTED = 'FILE_TYPE_NOT_SUPPORTED',
  EXCEED_MAX_FILE_SIZE_LIMIT = 'EXCEED_MAX_FILE_SIZE_LIMIT',
  EXCEED_MAX_FILE_LIMIT = 'EXCEED_MAX_SIZE_LIMIT',
  REQUEST_TIMED_OUT = 'REQUEST_TIMED_OUT',
}

export interface FileUploadProps {
  children: (props: ChildrenRenderProps) => JSX.Element;
  onSuccess: (response: FileUploadResponse, file: File) => unknown;
  filesCount?: number;
  onError?: (error?: Error | FileUploadError) => unknown;
  maxFiles?: number;
  maxFileSizeMB?: number;
  acceptFileTypes?: string | string[];
}

export interface FileUploadInputProps {
  getInputProps: DropzoneState['getInputProps'];
  getRootProps: DropzoneState['getRootProps'];
  loading: boolean;
  acceptFileTypes: FileUploadProps['acceptFileTypes'];
}

export interface FileUploadPreviewImgProps {
  file: UploadedFile;
  onDelete?: (file: UploadedFile) => void;
}

export interface FileUploadHookProps {
  loading: boolean;
  files: UploadedFile[];
  setFiles: SetFile;
}

export interface FileUploadCustomErrorProps {
  error: Error | FileUploadError;
  close: () => void;
  maxFileSizeMB?: FileUploadProps['maxFileSizeMB'];
  acceptFileTypes?: FileUploadProps['acceptFileTypes'];
}
